import moment from 'moment';

import fromObjectToKeys from 'utils/converters/object/fromObjectToKeys.util';
import equalShallow from 'utils/objects/equalShallow.util';
import owns from 'utils/objects/owns.util';
import isNilValue from 'utils/predicates/any/isNilValue.util';
import { isTimeEqual } from 'utils/predicates/time/compare.util';

const eqM = (a, b) => (a instanceof moment && b instanceof moment ? isTimeEqual(a, b) : null);

const eq = (a, b) => {
  if (Object.is(a, b)) return true;

  // since the above check will have both null or both undefined, this means they aren't same
  if (isNilValue(a) || isNilValue(b)) return false;
  if (0 === a && 0 === b) return true;
  if ('object' !== typeof a || 'object' !== typeof b) return Object.is(a, b);

  return null;
};

const equalProps = (a, b) => {
  if (eqM(a, b)) return true;

  const r1 = eq(a, b);
  if (null !== r1) return r1;

  const keys = new Set([...fromObjectToKeys(a), ...fromObjectToKeys(b)].map(String));

  for (const key of keys) {
    if (!owns(key, a) || !owns(key, b)) return false;

    const valA = a?.[key];
    const valB = b?.[key];

    if (eqM(valA, valB)) continue;

    const r2 = eq(valA, valB);
    if (false === r2) return r2;

    if (!equalShallow(valA, valB)) return false;
  }

  return true;
};

export default equalProps;
